import {Routes, Route} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_ePulse/layout/core'
import { PatientListTable } from './table-list/table/PatientListTable'

const breadcrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
]

const PatientPage = () => (
  <Routes>
    <Route
      path='/'
      element={
        <>
          <PageTitle breadcrumbs={breadcrumbs}>Patient</PageTitle>
          <PatientListTable />
        </>
      }
    />
  </Routes>
)

export default PatientPage
